import React, { HTMLAttributes } from 'react';
import styles from './ContentContainer.module.css';

interface ContentContainerProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const ContentContainer: React.FC<ContentContainerProps> = ({ children, className = '', ...rest }) => {
  const classes = [styles.container, className].filter(Boolean).join(' ');

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
};

export default ContentContainer;